package com.eladfinish.bible.contest.appcontent

// NON-BREAKING HYPHEN: ‑
// Two capturing groups pick up the ta'am on God's name (if it's Qadma, it appears after the name).
// Dalet isn't an option for the 4th letter, so YEHUDA isn't taken for a version of God's name, and
// neither is a space (incl. NBSP — `\s` doesn't match it on every platform), or "מיהו האב" would
// match across the two words.
private val godNameRegex = "י(ְ?)ה(ֹ?)ו(ָ?)([^ד\\s\u00A0]?)ה(\\S?)".toRegex()

/** Writes God's name with a hyphen ("י‑הוה"), as the app shows it in questions. */
fun String.withGodNameHyphenated(): String =
    replace(godNameRegex, "י" + "$1" + "‑" + "ה" + "$2" + "ו" + "$3" + "$4" + "ה" + "$5")
